var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.coordinatesDialog,
        "content-class": "request-field-item-dialog",
        persistent: "",
        width: "400"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "home-form-container",
          staticStyle: { height: "180px" },
          attrs: { color: "#f0f0ef" }
        },
        [
          _c(
            "v-card-text",
            {
              staticClass: "home-form-container",
              staticStyle: {
                "text-align": "left",
                padding: "3px 0 0 0",
                overflow: "visible"
              }
            },
            [
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Latitude"),
                  "input-type": "float",
                  required: true,
                  size: "100"
                },
                model: {
                  value: _vm.coordinates.latitude,
                  callback: function($$v) {
                    _vm.$set(_vm.coordinates, "latitude", $$v)
                  },
                  expression: "coordinates.latitude"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Longitude"),
                  "input-type": "float",
                  required: true,
                  size: "100"
                },
                model: {
                  value: _vm.coordinates.longitude,
                  callback: function($$v) {
                    _vm.$set(_vm.coordinates, "longitude", $$v)
                  },
                  expression: "coordinates.longitude"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticStyle: { padding: "10px 20px 0 0" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c("management-button", {
                attrs: { type: "cancel", label: _vm.$t("Cancel") },
                on: { buttonClick: _vm.closeCoordinatesDialog }
              }),
              _vm._v(" "),
              _c("management-button", {
                attrs: {
                  type: "execute",
                  label: _vm.$t("Center"),
                  disabled: !_vm.validCoordinates
                },
                on: { buttonClick: _vm.centerOnCoordinates }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f863544", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f863544","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/Workspaces/WorkspaceCoordinates.vue
// module id = null
// module chunks = 